<mobi-breadcrumb />
@if (personSchema()) {
  <mobi-ld-schema [schema]="personSchema()" />
}
<div class="mobi-ui-person-header">
  @if (
    hasLocation() && entity().locationActivity[0].location?.generalAgency?.headerImage
  ) {
    <div
      class="hero-image-animation-wrapper lgMax:full-bleed lgMax:!rounded-none mobi-ui-margin-t-sm"
    >
      <mobi-media
        [animation]="false"
        class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300"
        rounded="none"
        [entity]="entity().locationActivity[0].location.generalAgency?.headerImage"
        responsiveStyle="hero_single"
        [lazy]="false"
      />
    </div>
  }
</div>
<div class="page-content person-info mobi-ui-font-size-200 !mt-0">
  <mobi-content-section [content]="content">
    <ng-template #content>
      <div class="mobi-ui-grid">
        <div class="mobi-ui-col-1/3 md:mobi-ui-col-1/4">
          @if (entity().image) {
            <div
              class="person-image rounded-[var(--mobi-ui-border-radius-lg)] aspect-3/4 border-white"
              [attr.data-delay]="100"
              [class.no-header]="
                !hasLocation() ||
                (hasLocation() &&
                  (!entity().locationActivity[0].location.generalAgency ||
                    !entity().locationActivity[0].location.generalAgency?.headerImage))
              "
            >
              <mobi-media
                class="person-portrait"
                [entity]="entity().image"
                responsiveStyle="person_portrait"
              />
            </div>
          }
        </div>
        <div class="mobi-ui-col-1/1 md:mobi-ui-col-3/4">
          <div class="mobi-ui-padding-y-lg smMax:!pt-0 smMax:-mt-3">
            <h1 class="mobi-ui-font-h2 smMax:!mt-0">
              {{ entity().firstName }} {{ entity().lastName }}
            </h1>
            @if (entity().functionText) {
              <mobi-text class="text-lead block" [data]="entity().functionText ?? ''" />
            }
            @if (
              !entity().functionText &&
              entity().functionTaxonomy &&
              entity().functionTaxonomy?.label
            ) {
              <mobi-text
                class="text-lead block"
                [data]="entity().functionTaxonomy?.label ?? ''"
              />
            }
          </div>
          <div class="mobi-ui-grid">
            <div class="person-contact mobi-ui-col-1/1 md:mobi-ui-col-1/2">
              @if (entity().alternativeEmail || entity().email) {
                <mobi-contact-card
                  [id]="'email-contact-' + entity().id"
                  type="email"
                  [agency]="
                    hasLocation()
                      ? (entity().locationActivity[0].location.baseLang?.title ?? '')
                      : ''
                  "
                  [title]="'email' | texts: { context: 'frontend', default: 'Email' }"
                  [content]="entity().alternativeEmail ?? entity().email ?? ''"
                  [link]="'mailto:' + (entity().alternativeEmail ?? entity().email)"
                  icon="mail_electronic"
                />
              }
              @if (entity().phone) {
                <mobi-contact-card
                  [id]="'phone-contact-' + entity().id"
                  type="phone"
                  [agency]="
                    hasLocation()
                      ? (entity().locationActivity[0].location.baseLang?.title ?? '')
                      : ''
                  "
                  [title]="'phone' | texts: { context: 'frontend', default: 'Telefon' }"
                  [content]="entity().phone ?? ''"
                  [link]="'tel:' + entity().phone?.replaceAll(' ', '')"
                  icon="telephone"
                />
              }
              @if (entity().mobilePhone) {
                <mobi-contact-card
                  type="phone"
                  [id]="'mobile-contact-' + entity().id"
                  [agency]="
                    hasLocation()
                      ? (entity().locationActivity[0].location.baseLang?.title ?? '')
                      : ''
                  "
                  [title]="
                    'mobile_phone'
                      | texts: { context: 'frontend', default: 'Mobiltelefon' }
                  "
                  [content]="entity().mobilePhone ?? ''"
                  [link]="'tel:' + entity().mobilePhone?.replaceAll(' ', '')"
                  icon="smartphone_portrait"
                />
              }
              @if (entity().bookingLink && !gaOnAp()) {
                <mobi-contact-card
                  type="online-booking-request"
                  [id]="'online-booking-' + entity().id"
                  [agency]="
                    hasLocation()
                      ? (entity().locationActivity[0].location.baseLang?.title ?? '')
                      : ''
                  "
                  [title]="
                    'online_booking'
                      | texts
                        : { context: 'frontend', default: 'Online Terminvereinbarung' }
                  "
                  [content]="
                    'online_booking_text'
                      | texts: { context: 'frontend', default: 'Termin vereinbaren' }
                  "
                  [link]="entity().bookingLink | extractUrl"
                  target="_blank"
                  icon="calendar_due_date"
                />
              } @else if (gaOnAp() && isActivityAllowed()) {
                <button
                  #gaOnApButton
                  type="button"
                  [id]="'online-booking-' + entity().id"
                  class="contact-card mb-4 cursor-pointer"
                  [attr.data-tracking]="
                    {
                      tealium_event: 'contact_request',
                      contact_type: 'online-booking-request',
                      agency_name: hasLocation()
                        ? (entity().locationActivity[0].location.baseLang?.title ?? '')
                        : '',
                    } | json
                  "
                  [mobiUiOverlay]="appointmentOverlay"
                >
                  <div class="contact-card__icon">
                    <mobi-ui-icon-major name="calendar_due_date" />
                  </div>

                  <div class="contact-card__text">
                    <span class="contact-card__label">
                      {{
                        'online_booking'
                          | texts
                            : {
                                context: 'frontend',
                                default: 'Online Terminvereinbarung',
                              }
                      }}
                    </span>
                    <span class="contact-card__value">
                      <mobi-text
                        [data]="
                          'online_booking_text'
                            | texts
                              : {
                                  context: 'frontend',
                                  default: 'Termin vereinbaren',
                                }
                        "
                      />
                    </span>
                  </div>
                </button>
                <ng-template #appointmentOverlay let-overlay>
                  <mobi-ui-overlay-major
                    class="is-full-size-content !max-w-[800px]"
                    size="md"
                    [overlay]="overlay"
                    [showCloseOverlayButton]="true"
                    trapFocus
                  >
                    <dip-terminvereinbarung-widget
                      [beraterprofil]="{
                        name: entity().firstName + ' ' + entity().lastName,
                        generalagentur:
                          hasLocation() &&
                          entity().locationActivity[0].location?.generalAgency
                            ? (entity().locationActivity[0].location.generalAgency
                                ?.title ?? '')
                            : '',
                        avatarSrc: rokkaAvatar(),
                      }"
                      [isAuthenticated]="false"
                      [workerEmail]="onapWorkerEmail()"
                      [language]="onapLanguage()"
                    />
                  </mobi-ui-overlay-major>
                </ng-template>
              }
              @if (mainLocation() && hasWap() && whatsAppPhone()) {
                <mobi-contact-card
                  [id]="'whatsapp-contact-' + entity().id"
                  type="whatsapp"
                  [agency]="hasLocation() ? (mainLocation()!.baseLang?.title ?? '') : ''"
                  [title]="
                    'whatsapp_info_title'
                      | texts: { context: 'frontend', default: 'WhatsApp Chat' }
                  "
                  [content]="whatsAppPhone()"
                  [link]="whatsAppLink()"
                  target="_blank"
                  icon="whatsapp"
                  [infoContent]="
                    'whatsapp_info_text'
                      | texts
                        : {
                            context: 'frontend',
                            default:
                              'Schreiben Sie uns auf WhatsApp – ganz einfach und unkompliziert.',
                          }
                  "
                  class="block"
                />
              }
            </div>
            <div class="person-socials mobi-ui-col-1/1 md:mobi-ui-col-1/2">
              <div class="mobi-ui-separator-minor mobi-ui-margin-none"></div>
              @if (entity().linkedinLink) {
                <mobi-icon-link
                  class=""
                  [title]="entity().linkedinLink?.title"
                  [link]="entity().linkedinLink | extractUrl"
                  [target]="entity().linkedinLink?.options?.attributes?.target"
                  icon="linkedin"
                />
                <div class="mobi-ui-separator-minor !m-0"></div>
              }
              @if (entity().facebookLink) {
                <mobi-icon-link
                  [title]="entity().facebookLink?.title"
                  [link]="entity().facebookLink | extractUrl"
                  [target]="entity().facebookLink?.options?.attributes?.target"
                  icon="facebook"
                />
                <div class="mobi-ui-separator-minor !m-0"></div>
              }
              @if (entity().xingLink) {
                <mobi-icon-link
                  [title]="entity().xingLink?.title"
                  [link]="entity().xingLink | extractUrl"
                  [target]="entity().xingLink?.options?.attributes?.target"
                  icon="xing"
                />
                <div class="mobi-ui-separator-minor !m-0"></div>
              }
              <mobi-file-download type="vcard" [id]="entity().id" />
              <div class="mobi-ui-separator-minor !m-0"></div>
              @if (entity().vagPdf && !entity().vagHidden) {
                <a
                  [href]="entity().vagPdf | extractUrl"
                  target="_blank"
                  class="mobi-file-download flex justify-between mobi-ui-width-full py-[12px] px-3"
                >
                  <div class="flex items-center">
                    <mobi-ui-icon-major
                      name="document"
                      class="mobi-ui-text-inked mobi-ui-margin-r-xxs"
                    />
                    <span class="text-black">
                      {{ entity().vagPdf.title }}
                    </span>
                  </div>
                  <mobi-ui-icon-major name="go_to_link" class="arrow mobi-ui-ink-grey" />
                </a>
                <div class="mobi-ui-separator-minor !m-0"></div>
              }
            </div>
            <div class="mobi-ui-col-1/1 overflow-auto no-scrollbar">
              <div
                class="mobi-ui-grid is-centered is-align-stretch items-separator min-w-[450px]"
              >
                @if (
                  entity().ciceroNr &&
                  ciceroImage() &&
                  entity().languages &&
                  entity().biyear
                ) {
                  <div class="mobi-ui-col-1/3 flex flex-col justify-center items-center">
                    <mobi-misc-item
                      [title]="
                        'cicero_number'
                          | texts
                            : {
                                context: 'frontend',
                                default: 'Cicero Member Nr.',
                              }
                      "
                      [content]="entity().ciceroNr"
                      icon="badge"
                    />
                    <div class="w-[96px] h-[96px]">
                      <mobi-media [entity]="ciceroImage()" />
                    </div>
                  </div>
                } @else {
                  @if (entity().ciceroNr && ciceroImage()) {
                    <div class="mobi-ui-col-1/3 flex justify-center items-center">
                      <div class="w-[96px] h-[96px]">
                        <mobi-media [entity]="ciceroImage()" />
                      </div>
                    </div>
                  }
                  @if (entity().ciceroNr) {
                    <div class="mobi-ui-col-1/3 flex justify-center items-center">
                      <mobi-misc-item
                        [title]="
                          'cicero_number'
                            | texts
                              : {
                                  context: 'frontend',
                                  default: 'Cicero Member Nr.',
                                }
                        "
                        [content]="entity().ciceroNr"
                        icon="badge"
                      />
                    </div>
                  }
                }
                @if (entity().languages) {
                  <div class="mobi-ui-col-1/3 flex justify-center items-center">
                    <mobi-misc-item
                      [title]="
                        'languages' | texts: { context: 'frontend', default: 'Sprachen' }
                      "
                      [content]="entity().languages"
                      icon="message"
                    />
                  </div>
                }
                @if (entity().biyear) {
                  <div class="mobi-ui-col-1/3 flex justify-center items-center">
                    <mobi-misc-item
                      [title]="
                        'biyear' | texts: { context: 'frontend', default: 'Jahrgang' }
                      "
                      [content]="entity().biyear?.toString()"
                      icon="cake_birthday_on"
                    />
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </mobi-content-section>
  @if (entity().freeText2) {
    <mobi-content-section [content]="freeText2">
      <ng-template #freeText2>
        @if (entity().freeText2) {
          <div class="mobi-ui-grid">
            <div
              class="mobi-ui-col-1/1 md:mobi-ui-col-2/3 md:mobi-ui-offset-1/3 md:pl-6 lg:mobi-ui-col-3/4 lg:mobi-ui-offset-1/4"
            >
              <mobi-text class="text-read block" [data]="entity().freeText2 ?? ''" />
            </div>
          </div>
        }
      </ng-template>
    </mobi-content-section>
  }
  @if (video()) {
    <mobi-content-section [content]="videoRef">
      <ng-template #videoRef>
        <mobi-media class="block" [entity]="video()!" />
      </ng-template>
    </mobi-content-section>
  }
  @if (entity().area || entity().career || entity().education || entity().hobbies) {
    <div class="mobi-ui-grid is-centered is-small mobi-ui-margin-y-md">
      <div class="mobi-ui-col-1/1 !my-0 md:mobi-ui-col-3/4 lg:mobi-ui-col-2/4">
        @if (entity().area) {
          <div
            class="mobi-ui-card-silent is-row is-gap is-small mobi-ui-padding-md mobi-ui-margin-b-md"
          >
            <div class="mobi-ui-text-block-major mobi-ui-flex-1">
              <mobi-ui-icon-major name="sticker_tik"></mobi-ui-icon-major>
              <div class="mobi-ui-text-block-content-major">
                <span class="mobi-ui-text-block-title-major is-tisa">
                  {{
                    'person_area'
                      | texts
                        : { context: 'frontend', default: 'In dieser Region für Sie da' }
                  }}
                </span>
                <mobi-text class="text-read block" [data]="entity().area ?? ''" />
              </div>
            </div>
          </div>
        }
        @if (entity().career) {
          <div
            class="mobi-ui-card-silent is-row is-gap is-small mobi-ui-padding-md mobi-ui-margin-b-md"
          >
            <div class="mobi-ui-text-block-major mobi-ui-flex-1">
              <mobi-ui-icon-major name="folder_register"></mobi-ui-icon-major>
              <div class="mobi-ui-text-block-content-major">
                <span class="mobi-ui-text-block-title-major is-tisa">
                  {{
                    'person_career'
                      | texts: { context: 'frontend', default: 'Berufliche Laufbahn' }
                  }}
                </span>
                <mobi-text class="text-read block" [data]="entity().career ?? ''" />
              </div>
            </div>
          </div>
        }
        @if (entity().education) {
          <div
            class="mobi-ui-card-silent is-row is-gap is-small mobi-ui-padding-md mobi-ui-margin-b-md"
          >
            <div class="mobi-ui-text-block-major mobi-ui-flex-1">
              <mobi-ui-icon-major name="book_open"></mobi-ui-icon-major>
              <div class="mobi-ui-text-block-content-major">
                <span class="mobi-ui-text-block-title-major is-tisa">
                  {{
                    'person_education'
                      | texts: { context: 'frontend', default: 'Aus- und Weiterbildung' }
                  }}
                </span>
                <mobi-text class="text-read block" [data]="entity().education ?? ''" />
              </div>
            </div>
          </div>
        }
        @if (entity().hobbies) {
          <div
            class="mobi-ui-card-silent is-row is-gap is-small mobi-ui-padding-md mobi-ui-margin-b-md"
          >
            <div class="mobi-ui-text-block-major mobi-ui-flex-1">
              <mobi-ui-icon-major name="racket_tennis"></mobi-ui-icon-major>
              <div class="mobi-ui-text-block-content-major">
                <span class="mobi-ui-text-block-title-major is-tisa">
                  {{
                    'person_hobbies'
                      | texts
                        : {
                            context: 'frontend',
                            default: 'Persönliche Interessen & Hobbys',
                          }
                  }}
                </span>
                <mobi-text class="text-read block" [data]="entity().hobbies ?? ''" />
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (hasLocation() && entity().locationActivity[0].location?.generalAgency) {
    <mobi-content-section [content]="map" [background]="true">
      <ng-template #map>
        <!-- todo: check if mobi rating active, if not, re-add mb to title -->
        <div class="mobi-ui-flex items-center">
          @if (entity().locationActivity[0].location.generalAgency?.title) {
            <h2 class="mobi-ui-margin-r-lg !p-0">
              {{ entity().locationActivity[0].location.generalAgency?.title }}
            </h2>
          }
          @if (entity().locationActivity[0].location.generalAgency?.url) {
            <a
              [betterRouterLink]="
                entity().locationActivity[0].location.generalAgency?.url | extractUrl
              "
              aria-label="Go to General Agency page"
              class="mobi-ui-btn-icon-minor is-small mobi-ui-animation-trigger-hover"
            >
              <mobi-ui-icon-major
                name="right"
                class="mobi-ui-ink-grey mobi-ui-animation-horizontal-wiggle-hover-target"
              />
            </a>
          }
        </div>
        @defer (hydrate never) {
          @if (
            entity().locationActivity[0].location?.googlePlacesId &&
            !entity().locationActivity[0].location?.hideGoogleRatings
          ) {
            <mobi-google-rating
              class="mobi-ui-margin-b-xl"
              placeId="{{ entity().locationActivity[0]?.location?.googlePlacesId }}"
              [isInHeader]="false"
            />
          }
        }

        @defer (hydrate on viewport) {
          <mobi-map-small
            class="mobi-ui-width-full"
            [agency]="entity().locationActivity[0].location.generalAgency!.title"
            [location]="$any(entity().locationActivity[0]?.location)"
          />
        }
      </ng-template>
    </mobi-content-section>
  }
</div>
